import { Link } from 'react-router-dom';
import { hotComics, comics } from '@/mocks/comics';

export default function TrendingRank() {
  const ranks = [...hotComics, ...comics.filter((c) => !c.hot)].slice(0, 8);
  const top = ranks[0];

  return (
    <section className="border-y border-background-200/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl text-foreground-950">人气排行 TOP 8</h2>
          <p className="mt-2 text-sm text-foreground-600">根据站内追更热度与读者口碑实时更新</p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link
              to={`/comic/${top.id}`}
              data-product-shop
              className="group relative block h-80 overflow-hidden rounded-2xl border border-background-200/60 lg:h-full"
            >
              <img
                src={top.cover}
                alt={`${top.title}漫画封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
              <span className="absolute left-4 top-4 rounded bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                本周第一
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <h3 className="font-heading text-xl text-foreground-950">{top.title}</h3>
                <p className="mt-1 line-clamp-2 text-xs text-foreground-300">{top.description}</p>
                <p className="mt-2 text-xs text-accent-400">{top.latestChapter}</p>
              </div>
            </Link>
          </div>

          <ol className="lg:col-span-3">
            {ranks.slice(1).map((c, i) => (
              <li key={c.id} className="border-b border-background-200/50 last:border-0">
                <Link
                  to={`/comic/${c.id}`}
                  data-product-shop
                  className="group flex items-center gap-4 py-3 transition-colors hover:bg-background-50/60"
                >
                  <span className={`font-heading text-2xl ${i < 2 ? 'text-primary-400' : 'text-foreground-600'}`}>
                    {String(i + 2).padStart(2, '0')}
                  </span>
                  <span className="h-14 w-11 shrink-0 overflow-hidden rounded bg-background-300">
                    <img src={c.cover} alt={c.title} className="h-full w-full object-cover object-top" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-bold text-foreground-950 group-hover:text-primary-400">
                      {c.title}
                    </span>
                    <span className="mt-0.5 block truncate text-xs text-foreground-600">{c.tags.join(' · ')}</span>
                  </span>
                  <span className="hidden flex-col items-end sm:flex">
                    <span className="flex items-center gap-1 text-xs text-accent-400">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                      {c.rating}
                    </span>
                    <span className="mt-1 text-[11px] text-foreground-500">{c.views} 人气</span>
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}